import React from 'react';

import Button from 'CommonComponents/Button';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function ServiceCard({ service, onEdit, onDelete }) {
    return (
        <>
            <div className="text-base-tile-group-main text-base-tile-col">
                <div className="tw-flex tw-w-full">
                    <div className="tw-w-6/12">
                        <h6 className="tw-font-semibold">{service.name}</h6>
                        <div>{service.code}</div>
                    </div>
                    {service.description && (
                        <div className="tw-w-6/12">
                            <div>{service.description}</div>
                        </div>
                    )}
                </div>
            </div>
            <div className="text-base-tile-group-hover text-base-tile-row tw-absolute tw-top-0 tw-right-0">
                <small>
                    <Button variant="primary" onClick={() => onEdit(service)}>
                        <EditIcon className="tw-w-3 tw-h-3 tw-mr-2" />
                        {$t('Edit')}
                    </Button>
                </small>
                <small>
                    <Button variant="danger" onClick={() => onDelete(service)}>
                        <TrashIcon className="tw-w-3 tw-h-3" />
                        {$t('Delete')}
                    </Button>
                </small>
            </div>
        </>
    );
}
